export default __webpack_public_path__ + "static/media/default.3a31435c.PNG";